import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from 'components/dropdown';

export default function DealListingTypes({
  condoListings,
  leaseSpaceListings,
  lotListings,
  saleListing,
  onListingsSelect,
}) {
  const items = [];

  function renderItem(label, listings) {
    return (
      <Dropdown.Item
        eventKey={label}
        key={label}
        label={label}
        onClick={() => onListingsSelect(listings)}
      />
    );
  }

  if (saleListing) {
    items.push(renderItem('Sale', [saleListing]));
  }

  if (leaseSpaceListings && leaseSpaceListings.length > 0) {
    items.push(renderItem('Lease', leaseSpaceListings));
  }

  if (lotListings && lotListings.length > 0) {
    items.push(renderItem('Lot', lotListings));
  }

  if (condoListings && condoListings.length > 0) {
    items.push(renderItem('Condo', condoListings));
  }

  return <React.Fragment>{items}</React.Fragment>;
}

DealListingTypes.propTypes = {
  condoListings: PropTypes.array,
  leaseSpaceListings: PropTypes.array,
  lotListings: PropTypes.array,
  saleListing: PropTypes.object,
  onListingsSelect: PropTypes.func.isRequired,
};
